export enum ArticleType {
    Product = 0,
    Time = 1,
}